export const environment = {
  production: false,
  baseUrl: 'https://licenseapistaging.empyreancloud.com',
  apiEndpoint: 'https://licenseapistaging.empyreancloud.com',
  redirectUrl: 'https://licensestaging.empyreancloud.com/index.html',
  clientId: '8dfc3755-424e-46b8-956c-7bf58b4716a8',   // ClientID from AAD Client-App
  tenantId: '83064a9c-09d6-4bb7-a5f0-1f71a7981264',   // AAD TenantID
  resource: '8dfc3755-424e-46b8-956c-7bf58b4716a8',   // ClientID from AAD Server-App
  managementGid: "21c7cb4f-629f-4d94-9b95-0f3c056d7cfe" // AAD Group ID who can perform management actions
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts